<template>
  <div
    v-if="showDebug"
    style="position: fixed; z-index: 9000; opacity: 0.9; background: rgba(0, 0, 0, 0.9); padding: 10px"
  >
    <template
      v-for="(value, key) in settingsStore.state.value"
      :key="key"
    >
      <div
        style="cursor: pointer"
        :style="{ color: typeof value === 'boolean' ? 'yellow' : 'aquamarine' }"
        @click="toggleSetting(key)"
      >
        {{ key }}: {{ value }}
      </div>
    </template>
    <button
      v-if="authStore.state.isImpersonating"
      style="background-color: red; color: white; border: none; padding: 5px 10px; cursor: pointer; margin-top: 10px"
      type="button"
      @click="authStore.stopImpersonation()"
    >
      Stop Impersonating
    </button>
  </div>
  <div :data-loading="isLoading">
    <Notifications :dangerously-set-inner-html="true" />
    <ForcePasswordChangeModal v-if="mustChangePassword" />
    <RouterView />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import appStore from "@/store/app.js";
import authStore from "@/store/auth.js";
import emitenteStore from "@/store/emitente.js";
import settingsStore from "@/store/settings";
import ForcePasswordChangeModal from "@/components/auth/ForcePasswordChangeModal.vue";

const isLoading = computed(() => appStore.state.loadingCount > 0);
const showDebug = ref(false);
const mustChangePassword = computed(() => !!authStore.state.current_user?.must_change_password);

const toggleSetting = (key) => {
  if (typeof settingsStore.state.value[key] === "boolean") {
    settingsStore.state.value[key] = !settingsStore.state.value[key];
  }
};

onMounted(async () => {
  appStore.state.loadingCount += 1;
  if (authStore.isAuthenticated()) {
    await Promise.all([
      authStore.currentUserRequest(),
      settingsStore.fetchSettings(),
      emitenteStore.getEmitenteId() ? emitenteStore.refreshEmitente() : null,
    ]);
  }
  appStore.state.loadingCount -= 1;
  appStore.state.mounted = true;

  window.addEventListener("keydown", (e) => {
    if (e.ctrlKey && e.altKey && e.code === "KeyD") {
      showDebug.value = !showDebug.value;
      settingsStore.setLocalSetting("debug", showDebug.value);
    }
  });
});
</script>

<style src="./style.scss" lang="scss"></style>
